const RESET_VALUE = Symbol.for("com.tldraw.state/RESET_VALUE");
export {
  RESET_VALUE
};
//# sourceMappingURL=types.mjs.map
